// extracted by mini-css-extract-plugin
export default {"NoMessages":"styles_NoMessages__kVoZ4","container":"styles_container__sh5kH"};